import { api } from "@/api";
import { QueryProps } from "@/types/Api";
import { PaginatedMatchMovements } from "@/types/ApiResponses/OddsHistory";

export interface OddMovementsParams {
  windowMinutes: number;
  marketGroups?: number[];
  minChangePct?: number;
  startsWithinMinutes?: number;
  search?: string;
  lang: string;
  page: number;
  pageSize: number;
}

export const getOddMovements = async (
  props: QueryProps<OddMovementsParams>
): Promise<PaginatedMatchMovements> => {
  const res = await api.client.get("/odds-history/movements", {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
